import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-prompt-modal',
  templateUrl: './prompt-modal.component.html',
  styleUrls: ['./prompt-modal.component.scss']
})
export class PromptModalComponent implements OnInit {

  title: String = 'Warning!';
  hideNo = false;
  yesTitle = 'Yes';

  @Input() body: String = 'Are you sure you want to delete?';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
  }

  yes() {
    this.activeModal.close('yes');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/prompt-modal/prompt-modal.component.ts